import React, { useContext, useEffect } from 'react';
import { LinkWrapper, CardLinkText } from '@components/Card/Card.styled';
import Link from '@components/Link/Link';
import { AmplifyLogs, CodingConstants } from '@constants';
import { TaxDocumentProps } from '@components/types';
import { NewCardWrapper } from '@components/NewCard/NewCard.styled';
import { WidgetWrapper, Title, Content } from '@components/Widget/Widget.styled';
import { WidgetsContext } from '@context';
import { CaretRightIcon } from 'shared-ui-components';
import { InfoModal } from 'fmc-digital-common';
import { logUserEvent } from '@analytics/amplifyLogging';
import { useDisclose } from 'native-base';
import { InfoJson } from './InfoJson';
import { Wrapper } from '@components/AlertModal/AlertModal.styled';

//TODO - need to move this to bundle offer template card
const TaxDocumentWidget: React.FC<TaxDocumentProps> = ({ loanNumber, themeType, id }) => {
    const { taxDoc, turboTaxPopUp, taxDocumentWidget } = CodingConstants;
    const { isOpen, onClose, onToggle } = useDisclose(false);
    const { handleDocument } = useContext(WidgetsContext);

    const handle1098Click = () => {
        handleDocument(taxDoc, loanNumber);
        const turboTaxStatus = window.localStorage.getItem('TurboTaxStatusOnWidget');
        if (turboTaxStatus !== 'shown') {
            onToggle();
            logUserEvent(AmplifyLogs.turboTaxPopupDisplayed);
        }
    };

    useEffect(() => {
        if (id === turboTaxPopUp) {
            const turboTaxStatus = window.localStorage.getItem('TurboTaxStatus');
            if (turboTaxStatus !== 'shown') {
                onToggle();
                logUserEvent(AmplifyLogs.turboTaxPopupDisplayedViaLogin);
            }
        }
    }, [id]);

    return (
        <>
            {isOpen ? (
                <Wrapper>
                    <InfoModal
                        data={InfoJson}
                        isOpen={isOpen}
                        onClose={() => {
                            if (id === turboTaxPopUp) {
                                window.localStorage.setItem('TurboTaxStatus', 'shown');
                                logUserEvent(AmplifyLogs.turboTaxPopupClosedViaLogin);
                            } else {
                                window.localStorage.setItem('TurboTaxStatusOnWidget', 'shown');
                                logUserEvent(AmplifyLogs.turboTaxPopupClosed);
                            }
                            onClose();
                        }}
                        handleTaxBtnClick={(url: string) => {
                            if (id === turboTaxPopUp) {
                                logUserEvent(AmplifyLogs.turboTaxPopupButtonClickedViaLogin);
                            } else {
                                logUserEvent(AmplifyLogs.turboTaxPopupButtonClicked);
                            }
                            window.open(url);
                        }}
                    />
                </Wrapper>
            ) : null}
            {id === taxDocumentWidget ? (
                <NewCardWrapper themeType={themeType}>
                    <WidgetWrapper>
                        <img
                            src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/e9810627-8508-4c5f-b7f1-91b83e5c5489/items/bb34b2d3-d8f6-4b8d-8ee4-1e1a1860ab02/renditions/8cc09ccb-ec0f-4702-93b7-9d8045165bd4?binary=true"
                            width={54}
                            height={60}
                        />
                        <Title>Your 1098 Is Ready</Title>
                    </WidgetWrapper>
                    <Content>
                        2023 1098 tax forms are now available for your review. Click below to view and download your 1098. Your 1098 will
                        open in a new tab. Please turn off pop-up blockers to view your file.
                    </Content>
                    <LinkWrapper id="cardLink">
                        <CardLinkText>
                            <Link data-testid="viewTaxDocLink" onClick={handle1098Click}>
                                VIEW LATEST 1098
                            </Link>
                            {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                            {/*@ts-ignore*/}
                            <CaretRightIcon style={{ marginBottom: '4px' }} />
                        </CardLinkText>
                    </LinkWrapper>
                </NewCardWrapper>
            ) : null}
        </>
    );
};
export default React.memo(TaxDocumentWidget);
